import { Modal } from 'antd';
import React from 'react';
import style from './style.module.scss';

const DeactivateCouponModal = ({ isModalOpen, setIsModalOpen, deactivateCoupon, reload }) => {
  return (
    <Modal
      open={isModalOpen}
      destroyOnClose
      footer={null}
      closable={false}
      onCancel={() => setIsModalOpen(false)}
      className={style.couponDetailsModal}>
      <div className={style.wrapper}>
        <div className={style.header}>
          <h2>Deactivate coupon</h2>
          <span className={style.closeIcon} onClick={() => setIsModalOpen(false)}>
            ×
          </span>
        </div>

        <p className={style.description}>Are you sure that you want to deactivate this coupon?</p>

        <div className={style.footer}>
          <button className={style.closeBtn} onClick={() => setIsModalOpen(false)}>
            Close
          </button>

          <button
            className={style.deactivateBtn}
            onClick={() => {
              deactivateCoupon();
              reload();
              setIsModalOpen(false);
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}>
            Deactivate
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeactivateCouponModal;
